import React from "react";
import { useTranslation } from "react-i18next";

import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Box, Typography } from "@mui/material";

import { useDir } from "../hooks";

const EVOX_PINK = "#f14295";

const VoucherNextStepHint = () => {
  const { t } = useTranslation();
  const dir = useDir();

  return (
    <Box
      role="note"
      dir={dir}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        width: { xs: "100%", sm: "fit-content" },
        maxWidth: "100%",
        marginTop: 1.5,
        paddingBlock: 0.75,
        paddingInline: 1.25,
        border: "1px solid",
        borderColor: EVOX_PINK,
        borderRadius: 1.5,
        backgroundColor: "rgba(241, 66, 149, 0.07)",
        color: "text.primary",
        textAlign: "start",
      }}
    >
      <LocalOfferOutlinedIcon
        aria-hidden="true"
        sx={{ color: EVOX_PINK, fontSize: 19, flexShrink: 0 }}
      />
      <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
        {t("subscription.voucherNextStepHint")}
      </Typography>
    </Box>
  );
};

export default VoucherNextStepHint;
